import { render } from "./IPStage.vue?vue&type=template&id=ae2c8b00"
import script from "./IPStage.vue?vue&type=script&lang=js"
export * from "./IPStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__